
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { BACKEND_URL } from "./backendconfig";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./Signup.css";


const backend = BACKEND_URL.replace(/\/+$/, "");
function Eye({ crossed }) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
    <circle cx="12" cy="12" r="3" />
    {crossed && <path d="m3 3 18 18" />}
  </svg>;
}

export default function ProtectedCourse({
  children,
  initialMode = "login",
  onClose,
  onAuthenticated,
}) {
  const location = useLocation();

  const [status, setStatus] = useState("checking");
const [mode, setMode] = useState(initialMode);
const notified = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [resetMobile, setResetMobile] = useState("");
  const [resetTicket, setResetTicket] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [notice, setNotice] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

const [form, setForm] = useState({
  name: "",
  mobile: "",
  country_code: "91",
  city: "",
  state: "",
  country: "India",
  password: "",
});
 useEffect(() => {
  try {
    const savedMobile = localStorage.getItem("ltc-remembered-mobile");
    const savedPassword = localStorage.getItem("ltc-remembered-password");

    if (savedMobile) {
      setRememberMe(true);

      setForm((current) => ({
        ...current,
        mobile: savedMobile,
        password: savedPassword || "",
      }));
    }
  } catch {
    // Continue normally if browser storage is unavailable.
  }
}, []);

useEffect(() => {
  if (
    status === "authenticated" &&
    onAuthenticated &&
    !notified.current
  ) {
    notified.current = true;
    onAuthenticated();
  }
}, [status, onAuthenticated]);

useEffect(() => {
  if (!onClose) return;

  function handleEscape(event) {
    if (event.key === "Escape") {
      onClose();
    }
  }

  document.addEventListener("keydown", handleEscape);

  return () => {
    document.removeEventListener("keydown", handleEscape);
  };
}, [onClose]);
  useEffect(() => {
    const controller = new AbortController();

    async function checkSession() {
      try {
        const response = await fetch(`${backend}/users.php?action=session`, {
          credentials: "include",
          cache: "no-store",
          signal: controller.signal,
        });

        if (!response.ok) {
          throw new Error("Unable to check your login. Please try again.");
        }

        const data = await response.json();

        if (!controller.signal.aborted) {
          setStatus(data.authenticated === true ? "authenticated" : "guest");
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setError(error.message);
          setStatus("guest");
        }
      }
    }

    checkSession();

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (status !== "guest") return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [status]);

  function handleChange(event) {
    const { name, value } = event.target;

    setError("");
    setForm((current) => ({
      ...current,
      [name]: value,
    }));
  }

  function changeMode() {
    setShowPassword(false);
    setMode((current) => (current === "register" ? "login" : "register"));
    setError("");
    setNotice("");
    setResetTicket("");
    setConfirmPassword("");
  }

  function openForgot() {
    setResetMobile(form.mobile);
    setResetTicket("");
    setConfirmPassword("");
    setForm((current) => ({ ...current, password: "" }));
    setShowPassword(false);
    setShowConfirm(false);
    setError("");
    setNotice("");
    setMode("forgot");
  }

  async function handleRecovery(event) {
    event.preventDefault();
    if (busy) return;
    if (resetTicket && form.password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setBusy(true);
    setError("");
    setNotice("");
    try {
      const response = await fetch(`${backend}/users.php?action=${resetTicket ? "reset-password" : "check-mobile"}`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(resetTicket
          ? { mobile: resetMobile, ticket: resetTicket, password: form.password, confirm_password: confirmPassword }
          : { mobile: resetMobile }),
      });
      const data = await response.json();
      if (!response.ok) {
        if (data.restart) setResetTicket("");
        throw new Error(data.message || "Unable to continue.");
      }
      if (!resetTicket) {
        setResetTicket(data.ticket);
        setNotice("Mobile number found. Enter your new password.");
      } else {
        try {
          localStorage.removeItem("ltc-remembered-password");
        } catch { /* Storage may be disabled. */ }
        setRememberMe(false);
        setForm((current) => ({ ...current, mobile: resetMobile, password: "" }));
        setConfirmPassword("");
        setResetTicket("");
        setMode("login");
        setNotice("Password changed. Log in with your new password.");
      }
    } catch (error) {
      setError(error.message || "Unable to continue.");
    } finally {
      setBusy(false);
    }
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setNotice("");
    if (busy) return;
if (
  mode === "register" &&
  (!form.country_code || !form.mobile.replace(/\D/g, ""))
) {
  setError("Select a country code and enter your mobile number.");
  return;
}
    setBusy(true);
    setError("");
const payload =
  mode === "register"
    ? {
        name: form.name.trim(),
        mobile: form.mobile.trim(),
        country_code: form.country_code,
        city: form.city.trim(),
        state: form.state.trim(),
        country: form.country.trim(),
        password: form.password,
      }
    : {
        mobile: form.mobile.trim(),
        password: form.password,
        remember: rememberMe,
      };
    try {
      const response = await fetch(`${backend}/users.php?action=${mode}`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Unable to continue.");
      }

if (data.authenticated === true) {
  if (mode === "login") {
    try {
      if (rememberMe) {
        localStorage.setItem(
          "ltc-remembered-mobile",
          form.mobile.trim()
        );

        localStorage.setItem(
          "ltc-remembered-password",
          form.password
        );
      } else {
        localStorage.removeItem("ltc-remembered-mobile");
        localStorage.removeItem("ltc-remembered-password");
      }
    } catch {
      // Login still succeeds if browser storage is unavailable.
    }
  }

  setStatus("authenticated");

window.dispatchEvent(
  new CustomEvent("ltc-auth-changed", {
    detail: {
      authenticated: true,
      user: data.user || null,
    },
  })
);

  return;
}
      if (mode === "register" && data.success === true) {
        setMode("login");
        setForm((current) => ({ ...current, password: "" }));
        setError("Registration completed. Please log in to continue.");
        return;
      }

      throw new Error(data.message || "Please log in to continue.");
    } catch (error) {
      setError(error.message);
    } finally {
      setBusy(false);
    }
  }

  if (status === "checking") {
    return (
      <main className="ltc-course-auth-surface">
        <p role="status">Checking your login…</p>
      </main>
    );
  }

  if (status === "authenticated") {
    return children;
  }

  return (
    <div className="ltc-course-auth-overlay">
      <section
        className="ltc-course-auth-surface ltc-course-auth-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ltc-course-auth-title"
      >
        <div className="ltc-course-auth-card">
          {onClose ? (
  <button
    type="button"
    className="ltc-course-auth-close"
    aria-label="Close popup"
    onClick={onClose}
  >
    ×
  </button>
) : (
  <Link
    to="/"
    className="ltc-course-auth-close"
    aria-label="Close and return home"
  >
    ×
  </Link>
)}

          <div className="ltc-course-auth-header">
            <span className="ltc-course-auth-eyebrow">
              {location.pathname === "/free-demo"
                ? "WATCH FREE DEMO"
                : "EXPLORE YOUR COURSE"}
            </span>

            <h1 id="ltc-course-auth-title">
              {mode === "forgot" ? "Reset Your Password" : mode === "register" ? "Create Your Account" : "Welcome Back"}
            </h1>

            <p>
              {mode === "forgot"
                ? "Enter your registered mobile number to continue."
                : mode === "register"
                ? "Register to continue to your selected course."
                : "Log in to continue to your selected course."}
            </p>
          </div>

          {mode === "forgot" ? (
            <form className="ltc-course-auth-form" onSubmit={handleRecovery}>
              <fieldset className="ltc-course-auth-fields" disabled={busy}>
                <div className="ltc-course-auth-field">
                  <label htmlFor="recovery-mobile">Registered Mobile Number</label>
                  <input id="recovery-mobile" type="tel" name="mobile" autoComplete="tel"
                    placeholder="Enter mobile number without country code" autoFocus required
                    maxLength={25} value={resetMobile} readOnly={Boolean(resetTicket)}
                    onChange={(event) => { setResetMobile(event.target.value); setError(""); }} />
                </div>
                {resetTicket && (
                  <>
                    <div className="ltc-course-auth-field">
                      <label htmlFor="recovery-password">New Password</label>
                      <div className="ltc-course-auth-password">
                        <input id="recovery-password" name="password" type={showPassword ? "text" : "password"}
                          autoComplete="new-password" required maxLength={72} value={form.password} onChange={handleChange} />
                        <button className="ltc-course-auth-eye" type="button" aria-label={showPassword ? "Hide password" : "Show password"}
                          aria-pressed={showPassword} onClick={() => setShowPassword((value) => !value)}>
                          <Eye crossed={showPassword} />
                        </button>
                      </div>
                    </div>
                    <div className="ltc-course-auth-field">
                      <label htmlFor="recovery-confirm">Confirm Password</label>
                      <div className="ltc-course-auth-password">
                        <input id="recovery-confirm" name="confirm_password" type={showConfirm ? "text" : "password"}
                          autoComplete="new-password" required maxLength={72} value={confirmPassword}
                          onChange={(event) => { setConfirmPassword(event.target.value); setError(""); }} />
                        <button className="ltc-course-auth-eye" type="button" aria-label={showConfirm ? "Hide confirm password" : "Show confirm password"}
                          aria-pressed={showConfirm} onClick={() => setShowConfirm((value) => !value)}>
                          <Eye crossed={showConfirm} />
                        </button>
                      </div>
                    </div>
                    <button type="button" className="ltc-course-auth-switch"
                      onClick={() => { setResetTicket(""); setNotice(""); setError(""); setConfirmPassword(""); setForm((current) => ({...current, password: ""})); }}>
                      Change mobile number
                    </button>
                  </>
                )}
                {notice && <p className="ltc-course-auth-success" role="status">{notice}</p>}
                {error && <p className="ltc-course-auth-message" role="alert">{error}</p>}
                <button className="ltc-course-auth-submit" type="submit">
                  {busy ? "Please wait…" : resetTicket ? "Save New Password" : "Verify Mobile Number"}
                </button>
                <button className="ltc-course-auth-switch" type="button" onClick={() => {
                  setMode("login"); setError(""); setNotice(""); setResetTicket("");
                  setForm((current) => ({ ...current, password: "" }));
                }}>Back to login</button>
              </fieldset>
            </form>
          ) : (
          <form className="ltc-course-auth-form" onSubmit={handleSubmit}>
            <fieldset className="ltc-course-auth-fields" disabled={busy}>
              {mode === "register" && (
                <div className="ltc-course-auth-field">
                  <label htmlFor="auth-name">Full Name</label>
                  <input
                    autoFocus
                    id="auth-name"
                    name="name"
                    autoComplete="name"
                    value={form.name}
                    onChange={handleChange}
                    maxLength={100}
                    required
                  />
                </div>
              )}
<div className="ltc-course-auth-field">
  <label htmlFor="auth-mobile">Mobile Number</label>

  {mode === "register" ? (
    <PhoneInput
      country="in"
      enableSearch
      enableTerritories
      countryCodeEditable={false}
      disabled={busy}
      value={`${form.country_code}${form.mobile}`}
      containerClass="ltc-course-auth-phone"
      inputClass="ltc-course-auth-phone-input"
      buttonClass="ltc-course-auth-phone-button"
      dropdownClass="ltc-course-auth-phone-dropdown"
      searchPlaceholder="Search country or code"
      placeholder="Enter mobile number"
      inputProps={{
        id: "auth-mobile",
        name: "mobile",
        required: true,
        autoComplete: "tel",
      }}
      onChange={(value, country) => {
        const dialCode = country?.dialCode || "";
        const digits = value.replace(/\D/g, "");

        const mobile =
          dialCode && digits.startsWith(dialCode)
            ? digits.slice(dialCode.length)
            : digits;

        setError("");

        setForm((current) => ({
          ...current,
          mobile,
          country_code: dialCode,
          country: country?.name || current.country,
        }));
      }}
    />
  ) : (
    <input
      autoFocus
      id="auth-mobile"
      name="mobile"
      type="tel"
      autoComplete="username"
      placeholder="Enter registered mobile number"
      value={form.mobile}
      onChange={handleChange}
      maxLength={25}
      required
    />
  )}
</div>

              {mode === "register" && (
                <>
                  <div className="ltc-course-auth-grid">
                    <div className="ltc-course-auth-field">
                      <label htmlFor="auth-city">City</label>
                      <input
                        id="auth-city"
                        name="city"
                        autoComplete="address-level2"
                        value={form.city}
                        onChange={handleChange}
                        maxLength={100}
                        required
                      />
                    </div>

                    <div className="ltc-course-auth-field">
                      <label htmlFor="auth-state">State</label>
                      <input
                        id="auth-state"
                        name="state"
                        autoComplete="address-level1"
                        value={form.state}
                        onChange={handleChange}
                        maxLength={100}
                        required
                      />
                    </div>
                  </div>

                 <div className="ltc-course-auth-field">
  <label htmlFor="auth-country">Country</label>

  <input
    id="auth-country"
    name="country"
    autoComplete="country-name"
    value={form.country}
    readOnly
    required
  />
</div>
                </>
              )}

              <div className="ltc-course-auth-field">
                <label htmlFor="auth-password">Password</label>
                <div className="ltc-course-auth-password">
                  <input
                    id="auth-password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete={mode === "register" ? "new-password" : "current-password"}
                    value={form.password}
                    onChange={handleChange}
                    required
                  />
                  <button
                    type="button"
                    className="ltc-course-auth-eye"
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    aria-pressed={showPassword}
                    aria-controls="auth-password"
                    onClick={() => setShowPassword((current) => !current)}
                  >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12Z" />
                      <circle cx="12" cy="12" r="3" />
                      {showPassword && <path d="m3 3 18 18" />}
                    </svg>
                  </button>
                </div>
              </div>
              {mode === "login" && (
  <label className="ltc-course-auth-remember">
    <input
      type="checkbox"
      name="remember"
      checked={rememberMe}
      onChange={(event) => {
        const checked = event.target.checked;
        setRememberMe(checked);
        if (!checked) {
          try {
            localStorage.removeItem("ltc-remembered-mobile");
            localStorage.removeItem("ltc-remembered-password");
          } catch {
            // Browser storage may be disabled.
          }
        }
      }}
    />

    <span>Remember me</span>
  </label>
)}

              {mode === "login" && <button type="button" className="ltc-course-auth-forgot" onClick={openForgot}>Forgot password?</button>}
              {notice && <p className="ltc-course-auth-success" role="status">{notice}</p>}
              {error && (
                <p className="ltc-course-auth-message" role="alert">
                  {error}
                </p>
              )}

              <button type="submit" className="ltc-course-auth-submit">
                {busy
                  ? "Please wait…"
                  : mode === "register"
                    ? "Register & Continue"
                    : "Login & Continue"}
              </button>

              <button
                type="button"
                className="ltc-course-auth-switch"
                onClick={changeMode}
              >
                {mode === "register"
                  ? "Already registered? Log in"
                  : "New here? Create an account"}
              </button>
            </fieldset>
          </form>
          )}
        </div>
      </section>
    </div>
  );
}